/**
    NEED_IDENTIFICATION = nothing filled in Become form
    NEED_VALIDATION = has a foreign id
    NOK = blocked because of double
    OK = everything has been validated
    REFUSED = Identification refused
    NOT_PASSED = Initial value
 */

export enum IdentificationValidationEnum {
    OK = 'OK',
    NOT_PASSED = 'NOT_PASSED',
    NOK = 'NOK',
    NEED_IDENTIFICATION = 'NEED_IDENTIFICATION',
    NEED_VALIDATION = 'NEED_VALIDATION',
    REFUSED = 'REFUSED'
}